import type { GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200 } from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsUser } from '~/hooks';

type IUseUserDetailHeader = (userId: number) => {
  state: {
    data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200;
  };
};

/**
 * 利用者詳細ヘッダーのコンポーネントフック
 *
 * @param userId - 利用者ID
 */
export const useUserDetailHeader: IUseUserDetailHeader = userId => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetPartnerAdminsUser({ threeLetterCode, userId });

  return {
    state: {
      data,
    },
  };
};
